import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { token, isLoading } = useAuth();
  
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh', 
        background: '#F4F6F3',
        flexDirection: 'column',
        gap: '1rem',
        fontFamily: "'DM Sans', sans-serif"
      }}>
        <div style={{ 
          width: '40px', 
          height: '40px', 
          border: '4px solid #DCEFB8', 
          borderTop: '4px solid #084734', 
          borderRadius: '50%', 
          animation: 'spin 1s linear infinite' 
        }} />
        <p style={{ color: '#084734', fontWeight: 600 }}>Verifying session...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!token) return <Navigate to="/login" />;
  return children;
}
